/**
 * Rating status badge — shows "Provisional" or "Verified" next to ratings.
 * Usage: <RatingBadge status="provisional" /> or <RatingBadge status="verified" />
 */
export function RatingBadge({ status }) {
  if (status === 'verified') {
    return (
      <span className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 border border-green-200" data-testid="rating-badge-verified">
        Verified
      </span>
    );
  }
  if (status === 'provisional') {
    return (
      <span className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700 border border-amber-200" data-testid="rating-badge-provisional">
        Provisional
      </span>
    );
  }
  // not_rated or missing
  return (
    <span className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-500 border border-slate-200" data-testid="rating-badge-not-rated">
      Not Rated
    </span>
  );
}
